var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15041_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70653 0.398438C7.70653 0.398438 -0.775131 4.50845 0.492411 12.472C0.999427 14.089 5.4322 21.5611 13.7835 14.9651C14.544 14.5947 19.9836 6.75222 7.70653 0.398438Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.239298 9.8574C0.239298 9.8574 1.76035 10.8546 3.52766 9.7363C4.66483 8.73907 6.94641 8.48977 8.33708 10.2349C9.35111 10.7335 13.0234 11.2321 15.5512 9.23769C15.6743 11.4815 16.0582 15.7126 8.71372 17.5788C7.19267 17.6999 0.108922 17.4577 0.232055 9.86452L0.239298 9.8574Z",
    fill: "#F8FCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15041_1737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.b2d01ac691a7b561911bebc8ebe95f49.svg";
export { ForwardRef as ReactComponent };